export const SET_GOFT = 'api:set_goft';
export const SET_PAP = 'api:set_pap';
